import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-feedback',
    standalone: true,
    imports: [
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        RouterModule,
        CommonModule
        //HttpClientModule is autoprovided by the provideHttpClinet() provider in the app.module.ts
    ],
    templateUrl: './feedback.component.html'
})
export class FeedbackComponent implements OnDestroy {
  message: string = '';
  email: string = '';
  showSuccessMessage: boolean = false;
  userName?: string;
  userCheckSub: Subscription;

  constructor(private authService: AuthService, private http: HttpClient) {
    this.userCheckSub = this.authService.user$.subscribe(user => {
      if(user.loggedIn) {
        this.email = this.authService.user$.value.user!.email;
        this.userName = this.authService.user$.value.user!.firstName;
      }
    });
  }
  ngOnDestroy(): void {
    this.userCheckSub.unsubscribe();
  }

  submitFeedback() {
    this.http.post('/api/v1/feedback', { message: this.message, email: this.email }).subscribe();
    this.showSuccessMessage = true;
  } 
}